/* eslint-disable */

import React, { Component } from "react";

import { Link } from "react-router-dom";
import PDF_IMage from "../assets/images/pdf.png";
import A4 from "../assets/PDF FILE/AdvisoryBoardMeeting/A4.pdf";
import A3 from "../assets/PDF FILE/AdvisoryBoardMeeting/A3.pdf";
import A2 from "../assets/PDF FILE/AdvisoryBoardMeeting/A2.pdf";
import A1 from "../assets/PDF FILE/AdvisoryBoardMeeting/A1.pdf";
import A0 from "../assets/PDF FILE/AdvisoryBoardMeeting/A0.pdf";

function AdvBordMeeting() {
  return (
    <div>
      {/* <Header /> */}

      <section class="about section">
        <div class="container">
          <div class="row">
            {/* <div class="col-lg-6 col-md-12 col-sm-12"> */}
            <div class="about-content">
              <h3>
                Meetings <span>Detail</span>
              </h3>
              <table style={{ width: "100%" }}>
                <tr>
                  <th>Held on Dated</th>
                  <th>Hosting /Chairman</th>
                  <th>Guest Person</th>
                  <th>Attached PDF Files</th>
                </tr>
                <tr>
                  <td>09-09-1999.</td>
                  <td>Dr. Punjab Singh</td>
                  <td>
                    <span className="guest_name">Dr. A.K. Ray</span>, Economist,
                    Ministry of Agriculture, Govt. of India
                  </td>
                  <td>Nill</td>
                </tr>
                <tr>
                  <td>09-01-2002</td>
                  <td>Dr. G.B. Singh</td>
                  <td>
                    <span className="guest_name">Dr. A.K. Ray</span>, Economist,
                    Ministry of Agriculture, Govt. of India
                  </td>
                  <td>
                    <a href={A4}>
                      <img src={PDF_IMage} />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>26-05-2013</td>
                  <td>Professor V. S. Tomar</td>
                  <td>
                    <span className="guest_name">Dr. B.S. Bhandari</span>,
                    Economic Adviser, Ministry of Agriculture, GOI
                  </td>
                  <td>
                    <a href={A3}>
                      <img src={PDF_IMage} />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>06-11-2014</td>
                  <td>Professor V. S. Tomar</td>
                  <td>
                    <span className="guest_name">Shri P. C. Bodh</span>,
                    Economic Adviser, Ministry of Agriculture, GOI
                    <span className="guest_name">Shri Raghav Chandra</span>,
                    AS&FA, GOI
                  </td>
                  <td>
                    <a href={A2}>
                      <img src={PDF_IMage} />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>19-01-2019</td>
                  <td>Professor P. K. Bisen</td>
                  <td>
                    <span className="guest_name">Shri P. C. Bodh</span>,
                    Economic Adviser, Ministry of Agriculture, GOI{" "}
                  </td>
                  <td>
                    <a href={A1}>
                      <img src={PDF_IMage} />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>24-12-2021</td>
                  <td>Professor P. K. Bisen</td>
                  <td>
                    <span className="guest_name">
                      Dr. (Mrs.) Promodita Sathish
                    </span>
                    , Adviser (AER) Division, Ministry of Agriculture, GOI
                  </td>
                  <td>
                    <a href={A0}>
                      <img src={PDF_IMage} />
                    </a>
                  </td>
                </tr>
              </table>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>

      {/* <!-- Start Clients --> */}
      {/* <Footer /> */}
    </div>
  );
}

export default AdvBordMeeting;
